import BaseTrack from "./basetracks";
import {fromTimeToPixel, fromPixelToTime} from "../../../../../utils/timelineutils.js"

class TCTrack extends BaseTrack
{
    constructor (type, datas, file1, file2, channel, id, parent)
    {
        super (type, datas, file1, file2, channel, id, parent);

        this.defaultHeight = 18;
        this.minHeight = 18;
        this.maxHeight = 18;

        this.ontopmost = true;
        this.ontop = false;
        this.onbottom = false;
        this.onbottommost = false;



        this.height = this.defaultHeight;

        var style = getComputedStyle(document.body);
        this.backcolor = style.getPropertyValue('--timeline-tctrack-backcolor');        
  }


    isFixedHeight()
    {
        return true;
    }

    drawTitle(context, img, stimecode, width)
    {
        
        context.fillStyle = "#202020";
        context.fillRect(2,this.baseline+2,width-8,this.height -4);

        context.strokeStyle = "#808080";
        context.lineWidth = 0.5;
        context.strokeRect(2,this.baseline+2,width-8,this.height -4); // Draw rectangle border

        context.textBaseline = "middle";
        context.font = "12px courier new";
        context.fillStyle="White";
        context.fillText(stimecode,width/2-context.measureText(stimecode).width/2,this.baseline+10);                
    }

    redrawbackgroundLevel1(context, width, currentTime, sTimeCode, starttime, duration,fullheight, ystart)
    {

        if (width <=0) return;
        super.redrawForeGround(context,width);


        
        context.font = "12px courier new";
        context.fillStyle="White";
        var w = context.measureText("00:00:00:00").width;
        // calcul de la durée d'un time code
        var t = fromPixelToTime(w, width, 0, duration);

        var inc = Math.floor(t) + 2;

        
        context.textBaseline = "middle"

        var startdrawtime = Math.round(Math.floor(starttime) / 2) * 2;; //  Math.floor(starttime/2) * 2 -1;
        if (startdrawtime< 0) startdrawtime = 0;
        var enddrawtime = startdrawtime + duration+1;
        
        for (t = startdrawtime; t < enddrawtime; t = t + inc)
        {

            var xpos = fromTimeToPixel(t, width, starttime, duration);
            var y = this.baseline + 10;
            var stimecode =  this.parent.getTimeCodeString(t);
            context.fillText(stimecode,xpos - context.measureText(stimecode).width/2,y);                

            context.strokeStyle ="#404040";
            context.lineWidth = 1;
            context.beginPath();
            context.moveTo(xpos,this.height/2);
            context.lineTo(xpos,fullheight);
            context.stroke();
    
        }

    }

    
}

export default TCTrack;